enum ClockAction {
  CLOCK_IN = 'clock-in',
  CLOCK_OUT = 'clock-out',
  BREAK_START = 'break-start',
  BREAK_END = 'break-end',
  SWITCH = 'switch',
}

export default ClockAction;
